import { createFileRoute } from '@tanstack/react-router';
import { PrizeTierDefaultsPage } from '../pages/prize-tier-defaults/prize-tier-defaults-page';

export const Route = createFileRoute('/prize-tier-defaults/')({
  /*
   * `?tier=` drives the Prize Tier modal (CAE-1598) — `new` for an empty one,
   * a row id to edit that row. Hand-rolled rather than schema-validated because
   * zod is a devDependency of this app, not a runtime one, and the rule is one
   * line: anything that is not a string is no param at all. The page decides
   * what a string that names no row means.
   */
  validateSearch: (search: Record<string, unknown>): { tier?: string } => ({
    tier: typeof search.tier === 'string' && search.tier !== '' ? search.tier : undefined,
  }),
  component: PrizeTierDefaultsPage,
});
